import step1 from './steps/step1.json';
import step10 from './steps/step10.json';
import step2 from './steps/step2.json';
import step3 from './steps/step3.json';
import step4 from './steps/step4.json';
import step5 from './steps/step5.json';
import step6 from './steps/step6.json';
import step7 from './steps/step7.json';
import step8 from './steps/step8.json';
import step9 from './steps/step9.json';

const getWaltzData = () => ({
  name: 'What’s your rhythm?',
  url: 'waltz',
  mainColor: '#CA3BCF',
  steps: [
    step1,
    step2,
    step3,
    step4,
    step5,
    step6,
    step7,
    step8,
    step9,
    step10
  ],
  thumbnail: '/journey%20to%20success/00%20dashboard/thumbnails/entrepreneurial-mindset/whats-your-rhythm.svg',
  summary: 'Learn how the creative greats structured their more productive days.'
});

export {
  getWaltzData
};
